import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { useObservable } from '../../../shared/store';
import { PreferencesPanel } from './PreferencesPanel/PreferencesPanel';

/** PREF-UC-1, PREF-UC-2: подключает панель настроек к сессии и теме. Работает и до входа, и после. */
export function PreferencesControls({ compact = false }: { compact?: boolean }): ReactElement {
  const { session, theme } = useServices();
  const { locale } = useT();
  const themeState = useObservable(theme.state);
  return (
    <PreferencesPanel
      locale={locale}
      theme={themeState.theme}
      mode={themeState.mode}
      compact={compact}
      onLocaleChange={(next) => void session.setLocale(next)}
      onThemeChange={(next) => void session.setTheme(next)}
      onModeChange={(next) => void session.setColorMode(next)}
    />
  );
}
